import { useState, useEffect, useContext } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import DynamicIcon from './dynamic-icon';
import BusinessContext from '../../contexts/business-context';
import { set } from 'date-fns';

export default function ToastNotification({
    message,
    heading = 'Notification',
    isVisible,
    icon ='info',
    duration = Infinity,
    // onClose,
    type = 'info', // 'info', 'success', 'warning', 'error'
}) {
    const [isShowing, setIsShowing] = useState(isVisible);
    const { setNotificationContent, notificationContent } = useContext(BusinessContext);

    const onClose = () => {
        setNotificationContent(
            {
                ...notificationContent,
                showNotification: false,
            }
        );
        setIsShowing(false);
    };
    useEffect(() => {
        setIsShowing(isVisible);
        
        if(notificationContent.showNotification){
            setTimeout(() => {
                onClose();
            }, 5000);
        }
    }, [isVisible, duration, onClose, notificationContent]);

    const getTypeStyles = () => {
        switch (type) {
            case 'success': return 'bg-green-100 border-green-500 text-green-800';
            case 'warning': return 'bg-yellow-100 border-yellow-500 text-yellow-800';
            case 'error': return 'bg-red-100 border-red-500 text-red-800';
            default: return 'bg-blue-100 border-blue-500 text-blue-800';
        }
    };

    return (
        <AnimatePresence>
            {isShowing && (
                <motion.div
                    initial={{ x: '100%', opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: '100%', opacity: 0 }}
                    transition={{ duration: 0.3, ease: 'easeOut' }}
                    className={`fixed top-4 right-4 z-50 rounded-[8px] pr-[24px] pl-[16px] py-[10px] custom-bg-white-200 w-[335px]`}
                >
                    <div className='grid gap-[8px]'>
                        <div className='flex items-center justify-between'>
                            <div className='flex items-center gap-[8px]'>
                                <DynamicIcon name={icon !== null ? icon : 'info'} size={18}/>
                                <p className='poppins-medium text-[13px] custom-text-grey-900'>{heading}</p>
                            </div>
                            <DynamicIcon name='x' size={16} className='cursor-pointer' onClick={() => {onClose()}} />
                        </div>
                        <p className='poppins-regular text-[12px] custom-text-grey-900'>{message}</p>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}